export default [{
        name: '首页',
        path: '/',
        icon: 'ios-home-outline',
        authority: 'Manage Edit'
    },
    {
        name: '管理',
        icon: 'ios-paper-outline',
        authority: 'Manage Edit',
        children: [
            // {
            //     name: '公告管理',
            //     path: '/manage/announcement',

            //     authority: 'Manage'
            // },
            // {
            //     name: '评论管理',
            //     path: '/manage/comment',
            //     authority: 'Manage Edit'
            // },
            {
                name: '育人号管理',
                path: '/manage/studio',
                match: ['manageStudioSingle'], // 如匹配路由name也可激活<Menu:activeName>
                authority: 'Manage'
            },
            // {
            //     name: '广告管理',
            //     path: '/manage/ad',
            //     authority: 'Manage'
            // },
            // {
            //     name: '育人号审核',
            //     path: '/manage/fusionaudit',
            //     authority: 'Manage Audit'
            // },
            {
                name: '内容审核',
                path: '/manage/contentaudit',
                authority: 'Manage'
            },
            // {
            //     name: '返修管理',
            //     path: '/manage/fixedcontent',
            //     authority: 'Manage'
            // },
            // {
            //     name: '栏目管理',
            //     path: '/manage/tagword',
            //     authority: 'Manage'
            // },
            // {
            //     name: '水印管理',
            //     path: '/manage/watermark',
            //     authority: 'Manage'
            // },
            // {
            //     name: '系统配置',
            //     path: '/manage/configuration',
            //     authority: 'Manage'
            // },
            // {
            //     name: '账号管理',
            //     path: '/manage/account',
            //     match: ['manageAccountSingle'], // 如匹配路由name也可激活<Menu:activeName>
            //     authority: 'Manage'
            // },
            // {
            //     name: '换绑管理',
            //     path: '/manage/rebind',
            //     authority: 'Manage'
            // },
            // {
            //     name: '项目成员管理',
            //     path: '/manage/member',
            //     authority: 'Manage'
            // },
            // {
            //     name: '联络员管理',
            //     path: '/manage/liaison',
            //     authority: 'Manage'
            // },
            // {
            //     name: '工作量管理',
            //     path: '/manage/workload',
            //     authority: 'Manage'
            // },
            // {
            //     name: '发稿量配置',
            //     path: '/manage/draftcount',
            //     authority: 'Manage'
            // },
            // {
            //     name: '学校库管理',
            //     path: '/manage/database',
            //     authority: 'Manage'
            // },
            {
                name: '专家信息库',
                path: '/manage/expert',
                authority: 'Manage'
            },
        ]
    },
    {
        name: '数据统计',
        icon: 'stats-bars',
        authority: 'Manage Edit',
        children: [
            // {
            //     name: '数据统计',
            //     path: '/datastatistics/content',
            //     authority: 'Manage Edit',
            //     match: 'datasummary,exponential'
            // },
            {
                name: '育人号排序',
                path: '/datastatistics/sort',
                authority: 'Manage Edit'
            }
        ]
    },
    // {
    //     name: '渠道',
    //     icon: 'social-dropbox-outline',
    //     authority: 'Manage Edit',
    //     children: [{
    //             name: '内容接入',
    //             path: '/channel/minput',
    //             authority: 'Manage',
    //             match: 'miwechatlist,miwebsitelist'
    //         },
    //         {
    //             name: '内容接入',
    //             path: '/channel/einput',
    //             authority: 'Manage Edit',
    //             match: 'eiwechatadd,eiwebsiteadd'
    //         },
    //         {
    //             name: '内容输出',
    //             path: '/channel/eoutput',
    //             authority: 'Manage Edit',
    //             match: 'eowechatadd,eomicroblogadd'
    //         }
    //     ]
    // },
    // {
    //     name: '消息设置',
    //     icon: 'ios-bell-outline',
    //     classname:'xiaoxi',
    //     path: '/message',
    //     authority: 'Manage Edit',
    // },
    {
        name: '设置',
        icon: 'ios-gear-outline',
        authority: 'Manage Edit',
        children: [{
                name: '账号信息',
                path: '/settings/account',
                authority: 'Manage Edit'
            }
            // {
            //     name: '基本信息',
            //     path: '/settings/basic',
            //     authority: 'Manage Edit'
            // }
        ]
    },
    // {
    //     name: '系统管理',
    //     icon: 'ios-settings',
    //     authority: 'Manage Edit',
    //     children: [{
    //             name: '工作简报',
    //             path: '/system/work',
    //             authority: 'Manage Edit'
    //         }
    //     ]
    // }
]


// WEBPACK FOOTER //
// ./src/config/provinceAdmin.js